const stone = {
  100: "#F2F4F7",
  200: "#E4E7EC",
  300: "#D0D5DD",
  400: "#98A2B3",
  500: "#667085",
  600: "#475467",
  700: "#344054",
  800: "#1D2939",
  900: "#101828",
  contrastDefaultColor: "#ffffff"
}

export default stone
